import { addDays, addHours, addWeeks, eachDayOfInterval, endOfMonth, format, max, setHours, startOfDay, startOfMonth, startOfWeek, subDays } from 'date-fns'

export const CALENDAR_VIEW = {
    MONTH: "month",
    WEEK: "week",
}

const WEEK_OPTIONS = { weekStartsOn: 1 }
const DEFAULT_SCHEDULE_HOUR = 11
const CALENDAR_PATH = "/admin/calendar"

// calendarRange is the local [from, to) range of whole weeks shown by the view
export function calendarRange(view, date) {
    if (view === CALENDAR_VIEW.WEEK) {
        const from = startOfWeek(date, WEEK_OPTIONS)
        return { from, to: addWeeks(from, 1) }
    }
    return {
        from: startOfWeek(startOfMonth(date), WEEK_OPTIONS),
        to: addDays(startOfWeek(endOfMonth(date), WEEK_OPTIONS), 7),
    }
}

// calendarDays is every day shown by the view, at local midnight
export function calendarDays(view, date) {
    const { from, to } = calendarRange(view, date)
    return eachDayOfInterval({ start: from, end: subDays(to, 1) })
}

export function dayKey(day) {
    return format(day, "yyyy-MM-dd")
}

// groupItemsByDay groups the items by the local day they are at
export function groupItemsByDay(items) {
    const itemsByDay = new Map()
    for (const item of items || []) {
        const key = dayKey(new Date(item.At))
        itemsByDay.set(key, [...(itemsByDay.get(key) || []), item])
    }
    return itemsByDay
}

export function isEmptyDay(itemsByDay, day) {
    return !itemsByDay.get(dayKey(day))?.length
}

// isCreatableDay is true for today and future days, the only days shares can be created on
export function isCreatableDay(day, now = new Date()) {
    return startOfDay(day) >= startOfDay(now)
}

// defaultScheduledAt is 11:00 on a future day, and the later of 11:00 and an hour from now today or for a past day
export function defaultScheduledAt(day, now = new Date()) {
    if (startOfDay(day) > startOfDay(now)) {
        return setHours(startOfDay(day), DEFAULT_SCHEDULE_HOUR)
    }
    return max([setHours(startOfDay(now), DEFAULT_SCHEDULE_HOUR), addHours(now, 1)])
}

export function targetKey(shareTarget) {
    return `${shareTarget?.Type}:${shareTarget?.ID}`
}

// safeCalendarReturnTo returns the url only if it is a calendar page, so it can't redirect elsewhere
export function safeCalendarReturnTo(value) {
    if (typeof value === "string" && value.startsWith(CALENDAR_PATH)) {
        return value
    }
    return null
}
